// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".floor-form[data-v-5e0f8faf] {\n  display: flex;\n  gap: 10px;\n  max-width: 600px;\n}", ""]);
// Exports
module.exports = exports;
